import { Tabs, TabList } from "react-tabs"
import { StyledTab as Tab, StyledTabPanel as Panel } from "./index.styles"

Tab.tabsRole = "Tab" // Required to use custom Tab
Panel.tabsRole = "TabPanel" // Required to use custom Panel

export { Tab, Tabs, TabList, Panel }
